const BxfCheckboxMixedState2Obj = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><rect width="6" height="1.5" x="5" y="7.25"/></svg>',
};

export { BxfCheckboxMixedState2Obj as default };
